<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <div class="bg-img"></div>
      <div class="login-content">
        <div class="top">
          <div class="header">
            <img class="title" src="@/assets/logo_title.png" />
            <!-- </a> -->
          </div>
          <div class="desc"></div>
        </div>
        <router-view />
      </div>

      <!-- <div class="footer">
        <div class="links">
          <a href="_self">帮助</a>
          <a href="_self">隐私</a>
          <a href="_self">条款</a>
        </div>
        <div class="copyright">
          Copyright &copy; 2018 vueComponent
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'

export default {
  name: 'UserLayout',
  mixins: [deviceMixin],
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    background: #f0f2f5 url(~@/assets/img/bj.png) no-repeat 50%;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    .bg-img {
      width: 30%;
      // background: url(~@/assets/img/bj_pt.png) no-repeat;
      background-size: 90%;
      background-position: center;
    }
    .login-content {
      width: 70%;
      height: 100vh;
      display: flex;
      // align-items: center;
      flex-direction: column;
      justify-content: center;
      background: url(~@/assets/img/mengceng.png) no-repeat 10%;
      background-size: 100%;
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
      .top {
        text-align: center;
        .header {
          // height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }
          .title {
            width: 40%;
            position: relative;
          }
        }
      }
    }
    .main {
      min-width: 260px;
      width: 50%;
      margin: 90px auto 0;
    }
    .login-content::-webkit-scrollbar {
      display: none;
    }
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px) {
  #userLayout.user-layout-wrapper {
    .container {
      .login-content {
        width: 57%;
        height: 100vh;
        .top {
          .header {
            .title {
              width: 40%;
              position: relative;
            }
          }
        }
      }
      .main {
        margin: 45px auto 0;
        /deep/ .user-layout-login .user-input {
          height: 170px;
        }
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  #userLayout.user-layout-wrapper {
    .container {
      .login-content {
        .top {
          .header {
            .title {
              width: 40%;
              position: relative;
            }
          }
        }
      }
      .main {
        margin: 40px auto 0;
        /deep/ .user-layout-login .user-input {
          height: 160px;
        }
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1500px) {
  #userLayout.user-layout-wrapper {
    .container {
      .login-content {
        .top {
          .header {
            .title {
              width: 40%;
              position: relative;
            }
          }
        }
      }
      .main {
        margin: 40px auto 0;
        /deep/ .user-layout-login .user-input {
          height: 160px;
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  #userLayout.user-layout-wrapper {
    .container {
      .login-content {
        .top {
          .header {
            .title {
              width: 40%;
              position: relative;
            }
          }
        }
      }
      .main {
        margin: 27px auto 0;
        /deep/ .user-layout-login .user-input {
          height: 147px;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #userLayout.user-layout-wrapper {
    .container {
      .login-content {
        .top {
          .header {
            .title {
              width: 40%;
              position: relative;
            }
          }
        }
      }
      .main {
        margin: 17px auto 0;
        /deep/ .user-layout-login .user-input {
          height: 147px;
        }
      }
    }
  }
}
</style>
